import { buildFiltersFromUrlParamsHandlers } from './build-filters-from-url-params-handlers';

export const buildFiltersObjectFromFiltersArray = (params: string[][]) => {
  const filtersObject: { [key: string]: string[] } = {};

  const stringCasesArray = [' = ', ' TO '];

  params.flat(1).map(param => {
    stringCasesArray.find(stringCase => {
      if (param.includes(stringCase)) {
        const buildFiltersBasedOnParams =
          buildFiltersFromUrlParamsHandlers[stringCase];

        const filter = buildFiltersBasedOnParams(param);

        if (Object.prototype.hasOwnProperty.call(filtersObject, filter.key)) {
          if (Array.isArray(filtersObject[filter.key])) {
            filtersObject[filter.key] = [
              ...(filtersObject[filter.key] as string[]),
              filter.value as string,
            ];
          }
        } else {
          filtersObject[filter.key] = [filter.value as string];
        }
      }
    });
  });

  return filtersObject;
};
